import {
  Children,
  isValidElement,
  type PropsWithChildren,
  type ReactElement,
} from 'react';

import type { TooltipItem } from '../../../types/tooltip.js';

export function getCustomActionItems<T = unknown>(
  actions?: (t?: T) => ReactElement<PropsWithChildren> | undefined,
  item?: TooltipItem,
): ReactElement<PropsWithChildren>[] {
  if (!actions) {
    return [];
  }

  const actionItems = item
    ? actions(item as T)?.props.children
    : actions()?.props.children;

  return Children.toArray(actionItems).filter(
    isValidElement<PropsWithChildren>,
  );
}
